import Vue from 'vue';
import { EVENTS } from '@/Common/Runtime/events';
import { emitWrap, emitNavigationWrap, emitNotificationWrap } from '@/Common/Runtime/emitters';
import { VueClass } from 'vue-class-component/lib/declarations';
import { ux1Data } from '@/Common/Utils/General/Modules';
import View from '@/Common/Runtime/AppsCollector/View';
import { EmitWrap } from '../../../../types';

// fix for OA-34602, remove serviceTemplateId from view.id
export function removeServiceTemplateId(viewId: string): { viewId: string; serviceTemplateId: string } {
	const { serviceTemplateId } = window.aps.context._view;

	if (serviceTemplateId && viewId.includes(`-${serviceTemplateId}`)) {
		return { viewId: viewId.replace(`-${serviceTemplateId}`, ''), serviceTemplateId };
	} else {
		return { viewId, serviceTemplateId: '' };
	}
}

export default class App {
	protected el: Host.WCElement;

	public id: string;
	public views: Common.IMap<View> = {};
	public emit: EmitWrap;
	public emitNavigation: EmitWrap;
	public emitNotification: EmitWrap;

	constructor(id: string, el: Host.WCElement) {
		this.id = id;
		this.el = el;

		this.emit = emitWrap(this.el);
		this.emitNavigation = emitNavigationWrap(this.el);
		this.emitNotification = emitNotificationWrap(this.el);

		const { nameApp, router } = this.vueComponent;

		const views = (router.routes || []).map((route) => route.replace(`${nameApp}-`, ''));
		views.forEach((view) => {
			const viewId = ux1Data.changeCase.paramCase(view);
			this.views[viewId] = new View(viewId);
		});
	}

	public get vueComponent(): App.IMainContainer {
		return this.el.vueComponent;
	}
	public getComponent = (name: string): VueClass<Vue> | null => this.vueComponent.getComponent(name);

	public isReady = (): boolean => this.vueComponent.isReady;
	public activate = (): boolean => (this.vueComponent.isReady = true);
	public addListener = (listener: EventListener): void => this.el.addEventListener(EVENTS.PUBLIC.TO_HOST, listener);
	public removeListener = (listener: EventListener): void =>
		this.el.removeEventListener(EVENTS.PUBLIC.TO_HOST, listener);

	public apply = (id: string, functionName: string, args: APS.ICustomData): boolean => {
		// fix for OA-34602, remove serviceTemplateId from view.id
		const { viewId } = removeServiceTemplateId(id);

		const view = this.views[viewId];
		view && view.apply(functionName, args);
		return !!view;
	};
}
